import CryptoJS from "crypto-js";
import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/login",
    name: "login",
    props: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "about" */ "../views/LoginView.vue"),
  },
  {
    path: "/ordenes",
    name: "orders",
    props: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "home" */ "../views/OrdersView.vue"),
  },
  {
    path: '/mercadopago/resultado',
    name: 'MercadoPagoResultado',
    component: () => import('@/views/MercadoPagoResultado.vue')
  },
  {
    path: '/pago-pendiente/:buyOrder',
    name: 'PagoPendiente',
    component: () => import('@/views/PagoPendiente.vue')
  },
  {
    path: "/usuarios",
    name: "user",
    props: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/UserView.vue"),
  },
  {
    path: "/usuarios/edit/:id",
    name: "edit",
    props: {
      auth: true,
    },
    component: () =>
      import(/* webpackChunkName: "user" */ "../views/UserView.vue"),
  },
  {
    path: "/confirmar-pago/:sessionId",
    name: "confirm-payment",
    props: {
      auth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "confirm-payment" */ "../views/ConfirmPaymentView.vue"
      ),
  },
  {
    path: "/redireccionando/:buy_order",
    name: "redirect-payment",
    props: {
      auth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "redirect-payment" */ "../views/RedirectView.vue"
      ),
  },
  {
    path: "/procesando",
    name: "process-payment",
    props: {
      auth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "process-payment" */
        "../views/ProcessPaymentView.vue"
      ),
  },
  {
    path: "/pago-rechazado",
    name: "payment-declined",
    props: {
      auth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "payment-declined" */ "../views/PaymentDeclinedView.vue"
      ),
  },
  {
    path: "/order-error",
    name: "order-error",
    props: {
      auth: false,
    },
    component: () =>
      import(
        /* webpackChunkName: "order-error" */ "../views/ConfirmPaymentViewError.vue"
      ),
  },
  {
    path: "/pago-error",
    name: "payment-error",
    props: {
      auth: false,
    },
    component: () => import("../views/ProcessPaymentError.vue"),
  },
  {
    path: "/pago-exitoso/:sessionId",
    name: "payment-done",
    props: {
      auth: false,
    },
    component: () => import("../views/PaymentDoneView.vue"),
  },
  {
    path: "/dashboard",
    name: "Dashboard",
    props: {
      auth: true,
    },
    component: () => import("@/views/Dashboard.vue"),
  },
  {
    path: "/:catchAll(.*)*",
    props: {
      auth: false,
    },
    name: "404",
    component: () => import(/* webpackChunkName: "404" */ "../views/404"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

const roles = function (to, _from, next) {
  let user = getUser();
  if (to.path === "/" || to.path === "/login") {
    if (user.rol === "admin")
      next({
        name: "Dashboard",
      });
    else
      next({
        name: "orders",
      });
  }
  if (to.name === "user" && user.rol !== "admin")
    next({
      name: "orders",
    });
  if (to.name === "Dashboard" && user.rol !== "admin")
    next({
      name: "orders",
    });
};
const getUser = function () {
  let userStore = localStorage.getItem("getCurrentUser");
  let user = JSON.parse(decryption(userStore));
  return user;
};
const decryption = function (encrypted) {
  const decrypted = CryptoJS.AES.decrypt(
    encrypted,
    process.env.LOCAL_STORE_KEY
  );
  return decrypted.toString(CryptoJS.enc.Utf8);
};

router.beforeEach((to, from, next) => {
  let guard = to.matched[0].props.default.auth;
  if (guard || to.path === "/") {
    const token = localStorage.getItem("token");
    let isAuthenticated = false;
    if (token) {
      isAuthenticated = true;
    } else if (token === null) {
      isAuthenticated = false;
    }
    if (isAuthenticated) roles(to, from, next);
    if (to.name !== "login" && !isAuthenticated)
      next({
        name: "login",
      });
    else next();
  } else next();
});

export default router;
